import React from 'react';
import { Menu } from 'antd';
import './app-header.style.scss';
import { 
    checkSearchPage,
    checkCancelPage,
    viewBookedTicketsReport,
    viewMasterTripReport,
    viewPassengerInfoReport,
    viewSalesReport,
    viewSharedTripSalesReport,
    viewMasterAgentSalesReport,
    viewTicketSearchReport,
    viewTicketSearchReportOld,
    viewRescheduledTicketReport,
    viewTripReport,
    blockedSeatsReport,
    viewPerformanceReport,
    viewTotalTransactionReport,
    cancelledSeatsReport,
    checkViewAbandonedReport,
    checkWebTicketSalesReport,
    checkWebTicketCancelReport,
    checkStaffPage,
    viewSmsReport ,
    viewTicketBookedAfterTripStartTime,
    viewSettlementReport,
    checkToViewTripsPageOfAdmin,
    checkToViewBulkTripVehicleUpdatePage,
    checkToViewPopularRoutesPageAdmin,
    checkToViewSchedulesPageOfAdmin,
    checkToViewStandardStopsPage,
    checkToViewAgentsPageOfAdmin,
    viewDemandDataReport,
    viewServiceCountReport,
    viewOccupancyReport,
    tripCreate,
    viewActiveBookings,
    viewTicketSharingReport,
    viewCostSummaryReportReport,
    viewTransactionSummaryReportReport,
    viewTrackingSummaryReport,
    viewRevenueReport,
    viewBusServiceCollectionReport,
    checkToViewCitiesPageAdmin,
    checkPrepaidOTAPage,
    checkToViewAddressBookPageAdmin,
    viewPrePaidReport,
    checkDashBoardPage,
    checkToViewOperatorConfig,
    checkToViewBusOperatorPage,
    checkToViewColourConfig,
    checkToViewOperatorWebsiteConfig,
    checkToViewExpenseConfig,
    checkToViewVechicleManagementPageAdmin,
    checkToViewTemporaryChangesPage,
    checkToViewBusesPageAdmin,
    checkToViewCancellationPolicyPage,
    checkToViewMetaDataPage,
    checkToViewTicketImportPage,
    checkToViewOtaSearchPage,
    checkOtherReport,
    checkRevenueReport,
    viewDriverAttendanceReport,
    viewExpenseReport,
    viewStopAnalysisReport,
    checkToViewBookingConfig,
    checkToViewBillingConfig,
    checkToViewDiscountConfig,
    viewSettlementAdmin,
    viewOwnSettlement,
    checkToSetSettlementOpeningBalance,
    checkToGenerateSettlementDraft
   } from './app.header.module';
import { dafidyUserCheck } from './../../utils/constant';
import { useLocation } from 'react-router-dom';
import Icon from '@ant-design/icons';
import dashboardIcon from './../../images/dashboard.png';

const { SubMenu } = Menu;

export const MenuWeb = (props) => {

    const {
        onClickAddressBookPage,
        onTicketSearchReportClick,
        onTicketSearchV2ReportClick,
        onRescheduledTicketReportClick,
        onMasterTripSheetReport,
        onViewPassengerInfoReportClick,
        onSalesReportClick,
        onSharedTripSalesReportClick,
        onMasterAgentSalesReportClick,
        onExpenseReportClick,
        onBookedTicketsClick,
        onTripSheetClick,
        onActiveBookingsClick,
        viewCancelClick,
        searchClick,
        staffClick,
        onBlockedReportClick,
        performanceReport,
        totalTransactionReport,
        cancelledSeatsReportClick,
        viewAbandonedReportClick,
        webTicketSalesReportClick,
        webTicketCancelReportClick,
        onClickSmsReport,
        onClickTicketsBookedAfterTripStartTime,
        onClickSettlementReport,
        onClickGstFilingReport,
        onClickDemandDataReport,
        onClickServiceCountReport,
        onClickOccupancyReport,
        onClickCostSummaryReport,
        onClickTransactionSummaryReport,
        onClickTrackingSummaryReport,
        openAdminTripsPage,
        openBulkTripVehicleUpdatePage,
        openAdminAgentsPage,
        tripCreatePage,
        popularRoutesPage,
        onClickNewTrip,
        onClickStandardStops,
        openSchedulesPage,
        onClickTicketSharing,
        onClickRevenue,
        onClickBusServiceCollectionReport,
        onClickCitiesPage,
        onClickTransactions,
        onPrepaidOTADashboardClick,
        operatorConfigClick,
        qbccConfigClick,
        busOperatorClick,
        settlementsOpeningBalanceClick,
        settlementsGenerateClick,
        settlementsHistoryClick,
        settlementBillingClick,
        bookingConfigClick,
        billingConfigClick,
        colourConfigClick,
        operatorWebsiteConfigClick,
        expenseConfigClick,
        discountConfigClick,
        dashboardClick,
        openAdminVechicleManagementPage,
        onClickTemporaryChanges,
        openAdminBusesPage,
        openCancellationPolicyPage,
        openCoachTypesPage,
        openThemeColorsPage,
        openRedbusCitiesPage,
        openTicketImportPage,
        onClickOtaSearchPage,
        onClickDriverAttendanceReport
      }=props;

    const location = useLocation();

    const preventDefault=(event)=>{
          event.preventDefault();
    }

    const renderMenuTxt=(txt,path)=>{
      if(txt=="Dashboard"){
        return(
          <Icon component={() => (<img src={dashboardIcon} className='dashboard-icon' />)} width={26} height={26} />
          );
      }else{
        return(
          <a href={path} onClick={preventDefault} target="_blank">{txt}</a>
        );
      }
    }
    
    return (
        <div>
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={[location.pathname]}
                  breakpoint="lg" collapsedWidth="0">
                {checkDashBoardPage()&&
                  <Menu.Item key="/dashboard" onClick={dashboardClick}>
                    {renderMenuTxt("Dashboard","/dashboard")}
                  </Menu.Item>
                }
                {checkSearchPage()&&
                <Menu.Item key="/home" onClick={searchClick}>
                      {renderMenuTxt("Search","/home")}
                </Menu.Item>
                }
                {checkToViewOtaSearchPage()&&
                <Menu.Item key="/ota-search" onClick={onClickOtaSearchPage}>OTA Search</Menu.Item>
                }
                {viewTicketSearchReport()&&
                <Menu.Item key="/view-ticket-search" onClick={onTicketSearchV2ReportClick}>
                  {renderMenuTxt("Ticket Search","/view-ticket-search")}
                </Menu.Item>
                }
                {checkPrepaidOTAPage()&&
                  <Menu.Item key="/prepaid-ota" onClick={onPrepaidOTADashboardClick}>Dashboard</Menu.Item>
                }
                {checkCancelPage()&&
                  <Menu.Item key="/view-cancel" onClick={viewCancelClick}>
                    {renderMenuTxt("Modify/Cancel","/view-cancel")} 
                  </Menu.Item>
                }
                <SubMenu key="report" title="Report">      
                  {viewTripReport()||viewMasterTripReport()?
                      <SubMenu title="Trip Sheet">
                          {viewTripReport()&&
                            <Menu.Item key="/report/tripsheet" onClick={onTripSheetClick}>
                              {renderMenuTxt("Trip Sheet","/report/tripsheet")}
                            </Menu.Item>
                          }
                          {viewMasterTripReport()&&
                            <Menu.Item key="/report/mastertripsheetreport" onClick={onMasterTripSheetReport}>
                              {renderMenuTxt("Master Trip Sheet Report","/report/mastertripsheetreport")} 
                            </Menu.Item>
                          }
                      </SubMenu>
                      :null
                    }

                {viewSalesReport()||viewSharedTripSalesReport()||viewMasterAgentSalesReport()||viewBookedTicketsReport()?
                  <SubMenu title="Sales">
                      {viewSalesReport()&&
                        <Menu.Item key="/report/salesreport" onClick={onSalesReportClick}>
                          {renderMenuTxt("Sales Report","/report/salesreport")}
                        </Menu.Item>
                      }
                      {viewSharedTripSalesReport()&&
                        <Menu.Item key="/report/sharedtripsales" onClick={onSharedTripSalesReportClick}>
                          {renderMenuTxt("Shared Trip Sales","/report/sharedtripsales")}
                        </Menu.Item>
                      }
                      {viewMasterAgentSalesReport()&&
                        <Menu.Item key="/report/masteragentsalesreport" onClick={onMasterAgentSalesReportClick}>
                          {renderMenuTxt("Master Agent Sales Report","/report/masteragentsalesreport")}
                        </Menu.Item>
                      }
                      {viewBookedTicketsReport()&&
                        <Menu.Item key="/report/bookedtickets" onClick={onBookedTicketsClick}>
                          {renderMenuTxt("Booked Tickets","/report/bookedtickets")}
                        </Menu.Item>
                      }
                  </SubMenu>
                  :null
                }
                {checkWebTicketSalesReport()||checkWebTicketCancelReport()?
                    <SubMenu title="Web Tickets">
                        {checkWebTicketSalesReport()&&
                            <Menu.Item key="/report/webticketsalesreport" onClick={webTicketSalesReportClick}>
                              {renderMenuTxt("Web Ticket Sales Report","/report/webticketsalesreport")} 
                            </Menu.Item>
                        }
                        {checkWebTicketCancelReport()&&
                            <Menu.Item key="/report/webticketcancelreport" onClick={webTicketCancelReportClick}>
                              {renderMenuTxt("Web Ticket Cancellation Report","/report/webticketcancelreport")} 
                            </Menu.Item>
                        }
                    </SubMenu>
                    :null
                }
                {checkRevenueReport()?
                <SubMenu title="Revenue">
                  {viewTotalTransactionReport()&&
                    <Menu.Item key="/report/totaltransactionreport" onClick={totalTransactionReport}>
                      {renderMenuTxt("Total Transaction Summary","/report/totaltransactionreport")}
                    </Menu.Item>
                  }
                  {viewPerformanceReport()&&
                    <Menu.Item key="/report/performancereport" onClick={performanceReport}>
                      {renderMenuTxt("Performance Report","/report/performancereport")}
                    </Menu.Item>
                  }
                  {viewSettlementReport()&&
                    <Menu.Item key="/report/settlementreport" onClick={onClickSettlementReport}>
                      {renderMenuTxt("Settlement Report","/report/settlementreport")}
                    </Menu.Item>
                  }
                  {viewSettlementReport()&&
                    <Menu.Item key="/report/gstfilingreport" onClick={onClickGstFilingReport}>
                      {renderMenuTxt("GST Filing Report","/report/gstfilingreport")}
                    </Menu.Item>
                  }
                  {viewCostSummaryReportReport()&&
                    <Menu.Item key="/report/costSummaryReport" onClick={onClickCostSummaryReport}>
                      {renderMenuTxt("Billing Report","/report/costSummaryReport")}
                    </Menu.Item>
                  }
                  {viewTransactionSummaryReportReport()&&
                    <Menu.Item key="/report/transactionSummaryReport" onClick={onClickTransactionSummaryReport}>
                      {renderMenuTxt("Transaction Summary","/report/transactionSummaryReport")}
                    </Menu.Item>
                  }
                  {viewRevenueReport()&&
                    <Menu.Item key="/report/revenuereport" onClick={onClickRevenue}>
                      {renderMenuTxt("Revenue Report","/report/revenuereport")}
                    </Menu.Item>
                  }
                  {viewPrePaidReport()&&
                    <Menu.Item key="/report/prepaidtransactions" onClick={onClickTransactions}>
                      {renderMenuTxt("Prepaid Transactions","/report/prepaidtransactions")}
                    </Menu.Item>
                  }
                  {checkViewAbandonedReport()&&
                    <Menu.Item key="/report/abandonedreport" onClick={viewAbandonedReportClick}>
                      {renderMenuTxt("Abandoned Transactions Report","/report/abandonedreport")}
                    </Menu.Item>
                  }
                  {viewBusServiceCollectionReport()&&
                    <Menu.Item key="/report/busservicecollection" onClick={onClickBusServiceCollectionReport}>
                      {renderMenuTxt("Bus Service Collection","/report/busservicecollection")}
                    </Menu.Item>
                  }
                </SubMenu>
                :null
                }
                {checkOtherReport()?
                <SubMenu title="Other Reports">
                      {viewActiveBookings()&&
                        <Menu.Item key="/report/ActiveBookings" onClick={onActiveBookingsClick}>
                          {renderMenuTxt("Active Bookings","/report/ActiveBookings")}
                        </Menu.Item>
                        }
                         {cancelledSeatsReport()&&
                        <Menu.Item key="/report/cancelledticketreport" onClick={cancelledSeatsReportClick}>
                          {renderMenuTxt("Ticket Cancellation Report","/report/cancelledticketreport")} 
                        </Menu.Item>
                        }
                         {blockedSeatsReport()&&
                        <Menu.Item key="/report/blockedreport" onClick={onBlockedReportClick}>
                          {renderMenuTxt("Blocked Tickets","/report/blockedreport")} 
                        </Menu.Item>
                        }
                        {viewPassengerInfoReport()&&
                        <Menu.Item key="/report/viewpassengersreport" onClick={onViewPassengerInfoReportClick}>
                          {renderMenuTxt("Frequent Travellers Report","/report/viewpassengersreport")}
                        </Menu.Item>
                        }
                         {viewTicketSearchReportOld()&&
                        <Menu.Item key="/report/ticketsearchreport" onClick={onTicketSearchReportClick}>
                          {renderMenuTxt("Ticket Search","/report/ticketsearchreport")} 
                        </Menu.Item>
                        }
                        {viewRescheduledTicketReport()&&
                        <Menu.Item key="/report/rescheduledTicketreport" onClick={onRescheduledTicketReportClick}>
                          {renderMenuTxt("Rescheduled Ticket","/report/rescheduledTicketreport")}
                        </Menu.Item>
                        }
                        {viewSmsReport()&&
                        <Menu.Item key="/report/smsreport" onClick={onClickSmsReport}>
                          {renderMenuTxt("SMS Report","/report/smsreport")} 
                        </Menu.Item>
                        }
                        {viewTicketBookedAfterTripStartTime()&&
                        <Menu.Item key="/report/ticketbookedafterdeparture" onClick={onClickTicketsBookedAfterTripStartTime}>
                          {renderMenuTxt("Tickets Booked After Departure","/report/ticketbookedafterdeparture")} 
                        </Menu.Item>
                        }
                         {viewDemandDataReport()&&
                        <Menu.Item key = "/report/demandDataReport" onClick = {onClickDemandDataReport}>
                          {renderMenuTxt("Demand Data Report","/report/demandDataReport")} 
                        </Menu.Item>
                        }
                        {viewServiceCountReport()&&
                        <Menu.Item key = "/report/viewServiceCountReport" onClick = {onClickServiceCountReport}>
                          {renderMenuTxt("Service Count","/report/viewServiceCountReport")}
                        </Menu.Item>
                        }
                        {viewOccupancyReport()&&
                        <Menu.Item key = "/report/occupancyReport" onClick = {onClickOccupancyReport}>
                          {renderMenuTxt("Occupancy Report","/report/occupancyReport")}
                        </Menu.Item>
                        }
                        {viewTransactionSummaryReportReport()&&
                        <Menu.Item key = "/report/transactionSummaryReport" onClick = {onClickTransactionSummaryReport}>
                          {renderMenuTxt("Transaction Summary","/report/transactionSummaryReport")}
                        </Menu.Item>
                        }
                        {viewTrackingSummaryReport()&&
                        <Menu.Item key = "/report/trackingSummaryReport" onClick = {onClickTrackingSummaryReport}>
                          {renderMenuTxt("Tracking Summary","/report/trackingSummaryReport")}
                        </Menu.Item>
                        }
                        {viewTicketSharingReport()&&
                        <Menu.Item key = "/report/ticketsharingreport" onClick = {onClickTicketSharing}>Seat Sharing Report</Menu.Item>
                        }
                        {viewDriverAttendanceReport()&&
                        <Menu.Item key = "/report/driverAttendanceReport" onClick = {onClickDriverAttendanceReport}>
                          {renderMenuTxt("Driver Attendance","/report/driverAttendanceReport")}
                        </Menu.Item>
                        }
                        {viewExpenseReport()&&
                          <Menu.Item key="/report/expense-report" onClick={onExpenseReportClick}>
                            {renderMenuTxt("Expense Report","/report/expense-report")}
                          </Menu.Item>
                        }
                        {viewStopAnalysisReport()&&
                          <Menu.Item key="/report/stop-analysis" onClick={props.onStopAnalysisReportClick}>
                            {renderMenuTxt("Stops Analysis","/report/stop-analysis")}
                          </Menu.Item>
                        }
                  </SubMenu>
                  :null
                  }
                </SubMenu>
                {checkToViewOperatorConfig()||checkToViewColourConfig()||checkToViewOperatorWebsiteConfig()||checkToViewCitiesPageAdmin()||checkToViewAddressBookPageAdmin()||checkToViewAgentsPageOfAdmin()||checkToViewTripsPageOfAdmin()||checkToViewBulkTripVehicleUpdatePage()||checkToViewSchedulesPageOfAdmin()||checkToViewStandardStopsPage()||checkToViewPopularRoutesPageAdmin()||checkToViewCancellationPolicyPage()||checkToViewMetaDataPage()||checkToViewTicketImportPage()||viewSettlementAdmin()||viewOwnSettlement()||checkToSetSettlementOpeningBalance()||checkToGenerateSettlementDraft()||checkToViewBusOperatorPage()||dafidyUserCheck()?
                   <SubMenu key="admin" title="Admin">
                      <SubMenu key="admin-trip" title="Trip">
                        {checkToViewTemporaryChangesPage()&&
                          <Menu.Item key="/admin/temporary-changes" onClick={onClickTemporaryChanges}>
                            {renderMenuTxt("Temporary Changes","/admin/temporary-changes")}
                          </Menu.Item>
                        }
                        {checkToViewCitiesPageAdmin()&&
                          <Menu.Item key="/cities" onClick={onClickCitiesPage}>
                            {renderMenuTxt("Cities","/admin/cities")}
                          </Menu.Item>
                        }
                        {checkToViewAddressBookPageAdmin()&&
                          <Menu.Item key="/admin/addressbook" onClick={onClickAddressBookPage}>
                            {renderMenuTxt("Address Book","/admin/addressbook")}
                          </Menu.Item>
                        }
                        {checkToViewTripsPageOfAdmin()&&
                          <Menu.Item key="/admin/trips" onClick={openAdminTripsPage}>
                            {renderMenuTxt("Trips","/admin/trips")}
                          </Menu.Item>
                        }
                        {checkToViewTripsPageOfAdmin()&&
                          <Menu.Item key="/new-trip" onClick={onClickNewTrip}>
                            {renderMenuTxt("In active trips","/new-trip")}
                          </Menu.Item>
                        }
                        {checkToViewBulkTripVehicleUpdatePage()&&
                          <Menu.Item key="/admin/bulk-trip-vehicle-update" onClick={openBulkTripVehicleUpdatePage}>
                            {renderMenuTxt("Bulk Trip Vehicle Update","/admin/bulk-trip-vehicle-update")}
                          </Menu.Item>
                        }
                        {checkToViewStandardStopsPage()&&
                        <Menu.Item key="/standard-stops" onClick={onClickStandardStops}>
                          {renderMenuTxt("Standard stops","/standard-stops")}
                        </Menu.Item>
                        }
                        {checkToViewSchedulesPageOfAdmin()&&
                        <Menu.Item key="/admin/schedule" onClick={openSchedulesPage}>
                          {renderMenuTxt("Schedules","/admin/schedule")}
                        </Menu.Item>
                        }
                        {tripCreate()&&
                        <Menu.Item key= "/trip-create" onClick= {tripCreatePage}>
                          {renderMenuTxt("Create Trip", "/trip-create")} 
                        </Menu.Item>
                        }
                        {checkToViewPopularRoutesPageAdmin()&&
                          <Menu.Item key= "/popular-routes" onClick= {popularRoutesPage}>
                            {renderMenuTxt("Popular Routes","/popular-routes")}
                          </Menu.Item>
                        }
                      </SubMenu>
                      <SubMenu key="admin-other" title="Other">
                        {checkToViewAgentsPageOfAdmin()&&
                          <Menu.Item key="/admin/users" onClick={openAdminAgentsPage}>
                            {renderMenuTxt("Users","/admin/users" )}
                          </Menu.Item>
                        }
                        {checkStaffPage()&&
                        <Menu.Item key="/staff" onClick={staffClick}>
                          {renderMenuTxt("Staff","/staff")}
                        </Menu.Item>
                        }
                        {checkToViewVechicleManagementPageAdmin() &&
                          <Menu.Item key="/admin/vehicle-management" onClick={openAdminVechicleManagementPage}>
                            {renderMenuTxt("Vehicle Management", "/admin/vehicle-management")}
                          </Menu.Item>
                        }
                        {checkToViewBusesPageAdmin()&&
                        <Menu.Item key= "/buses" onClick= {openAdminBusesPage}>
                          {renderMenuTxt("Buses","/admin/buses")}
                        </Menu.Item>
                        }
                        {checkToViewCancellationPolicyPage()&&
                        <Menu.Item key= "/cancellation-policy" onClick= {openCancellationPolicyPage}>
                          {renderMenuTxt("Cancellation Policy","/admin/cancellation-policy")}
                        </Menu.Item>
                        }
                        {checkToViewTicketImportPage()&&
                        <Menu.Item key="/admin/ticket-import" onClick={openTicketImportPage}>
                          {renderMenuTxt("Ticket Import","/admin/ticket-import")}
                        </Menu.Item>
                        }
                      </SubMenu>
                      {(checkToViewBookingConfig()||checkToViewBillingConfig()||checkToViewOperatorConfig()||checkToViewColourConfig()||checkToViewOperatorWebsiteConfig()||checkToViewExpenseConfig()||checkToViewBusOperatorPage()||checkToViewDiscountConfig()) &&
                        <SubMenu key="admin-config" title="Config">
                          {checkToViewOperatorConfig()&&
                            <Menu.Item key= "/operatorconfig" onClick= {operatorConfigClick}>
                              {renderMenuTxt("Operator Config","/admin/operatorconfig")}
                            </Menu.Item>
                          }
                          {checkToViewOperatorConfig()&&
                            <Menu.Item key= "/admin/qbcc-config" onClick= {qbccConfigClick}>
                              {renderMenuTxt("QBCC Config","/admin/qbcc-config")}
                            </Menu.Item>
                          }
                          {checkToViewBusOperatorPage()&&
                            <Menu.Item key= "/admin/bus-operator" onClick= {busOperatorClick}>
                              {renderMenuTxt("Bus Operator","/admin/bus-operator")}
                            </Menu.Item>
                          }
                          {checkToViewColourConfig() &&
                            <Menu.Item key="/admin/colourconfig" onClick={colourConfigClick}>
                              {renderMenuTxt("Colour Config", "/admin/colourconfig")}
                            </Menu.Item>
                          }
                          {checkToViewOperatorWebsiteConfig() &&
                            <Menu.Item key="/admin/operator-website-config" onClick={operatorWebsiteConfigClick}>
                              {renderMenuTxt("Operator Website Config", "/admin/operator-website-config")}
                            </Menu.Item>
                          }
                          {checkToViewExpenseConfig() &&
                            <Menu.Item key="/admin/expenseconfig" onClick={expenseConfigClick}>
                              {renderMenuTxt("Expense Config", "/admin/expenseconfig")}
                            </Menu.Item>
                          }
                          {checkToViewBookingConfig()&&
                          <Menu.Item key="/admin/booking-config" onClick={bookingConfigClick}>
                            {renderMenuTxt("Booking Config","/admin/booking-config")}
                          </Menu.Item>
                          }
                          {checkToViewBillingConfig()&&
                          <Menu.Item key="/admin/billing-config" onClick={billingConfigClick}>
                            {renderMenuTxt("Billing Config","/admin/billing-config")}
                          </Menu.Item>
                          }
                          {checkToViewDiscountConfig()&&
                          <Menu.Item key="/admin/discount-config" onClick={discountConfigClick}>
                            {renderMenuTxt("Discount Config","/admin/discount-config")}
                          </Menu.Item>
                          }
                        </SubMenu>
                      }
                      {(viewSettlementAdmin() || checkToSetSettlementOpeningBalance() || checkToGenerateSettlementDraft()) &&
                        <Menu.Item key="/settlements" onClick={settlementsGenerateClick}>
                          {renderMenuTxt("Settlements","/settlements")}
                        </Menu.Item>
                      }
                      {(viewOwnSettlement()) &&
                        <Menu.Item key="/settlement-billing" onClick={settlementBillingClick}>
                          {renderMenuTxt("Billing & Settlements","/settlement-billing")}
                        </Menu.Item>
                      }
                      {(checkToViewMetaDataPage() || dafidyUserCheck()) &&
                        <SubMenu key="admin-metadata" title="Metadata">
                          {checkToViewMetaDataPage() &&
                          <Menu.Item key="/admin/metadata/coach-types" onClick={openCoachTypesPage}>
                            {renderMenuTxt("Coach Types","/admin/metadata/coach-types")}
                          </Menu.Item>
                          }
                          {dafidyUserCheck() &&
                          <Menu.Item key="/admin/metadata/theme-colors" onClick={openThemeColorsPage}>
                            {renderMenuTxt("Theme Colors","/admin/metadata/theme-colors")}
                          </Menu.Item>
                          }
                        </SubMenu>
                      }
                      {dafidyUserCheck() &&
                        <Menu.Item key="/admin/redbus-cities" onClick={openRedbusCitiesPage}>
                          {renderMenuTxt("Redbus Cities","/admin/redbus-cities")}
                        </Menu.Item>
                      }
                    </SubMenu>
                  :
                  null
                }
                {checkToViewSchedulesPageOfAdmin()&&
                  <Menu.Item key="/admin/scheduleonhome" onClick={openSchedulesPage}>
                  {renderMenuTxt("Schedules","/admin/schedule")}
                  </Menu.Item>
                 }
            </Menu>
        </div>
    );
};

MenuWeb.defaultProps = {
};

MenuWeb.propTypes = {
    
};
